export default function MultiStepFormPage({ children, title }) {
  return <>{children}</>;
}
